export default __webpack_public_path__ + "static/media/logo-icon.f16212b6.png";